import React, {useState, useEffect} from 'react';
import Select from 'react-select';
import PayrollRow from './Payroll-Row';
import PayrollReportCreator from './PayrollReportCreator';
import '../../css/App.css'
import '../../css/bootstrap.min.css';
import Members from '../../users/Members'
import RequestVacation from '../RequestVacation';
import bootstrap from 'bootstrap';
import Time from '../../Time';

class Payroll extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      payrollList:[],
      payrollEmployee:"",
      payrollPeriod:{start:"",end:""},
      payrollGenerator:false,
      requestVacation:false,
      members:[],
    };

    this.callPayroll = this.callPayroll.bind(this)
    this.changeEmployee = this.changeEmployee.bind(this);
    this.openCloseReportGenerator = this.openCloseReportGenerator.bind(this)
    this.checkHolidays = this.checkHolidays.bind(this)
    this.addHolidays = this.addHolidays.bind(this)
    this.createShift = this.createShift.bind(this)
  }
 
  //Every time you change an employee this happens
  changeEmployee = async(selectedMember) =>{

    this.setState({payrollEmployee:selectedMember.value})
    let period = this.state.payrollPeriod;
    console.log(period)
    if(period.end == ''){
      console.log("Select a Period");
      return;
    }else{
      await this.callPayroll(selectedMember.value, period);
    }

    this.checkHolidays();

  }

  //Every time you change the period
  changePeriod = async(selectedPeriod) =>{

    this.setState({payrollPeriod:selectedPeriod.value})
    console.log(selectedPeriod.value);


      let member = this.state.payrollEmployee;
      if(member == ''){
        console.log("Choose a member")
        return;
      }else{
        await this.callPayroll(member, selectedPeriod.value);
      }
      
      this.checkHolidays()

  }

  checkHolidays = async() =>{
    console.log('Checking Holidays...')
      let holidays = await Time.getHolidays();
      let period = this.state.payrollPeriod;
      let startDate = new Date (period.start+'T12:00:00')
      let endDate = new Date(period.end+'T12:00:00')
      
      let holidayList = [];
      
      for(let holiday of holidays){
        let holidayDate = new Date(holiday.observedDate+'T12:00:00');
        if(holidayDate >= startDate && holidayDate <= endDate){
          //console.log(holiday.nameEn + ' is in this period')
          holidayList.push(holiday)
        }
      }
      
      //Now that we have the holidays that applies for this period
      //We need to check if the employee already have these holidays in the payroll

      if(holidayList.length > 0){
        for(let u = 0; u < holidayList.length; u++){
          console.log("Checking "+holidayList[u].nameEn);
          
          //Gets the payroll and check each line looking for the holidays
          let payList = this.state.payrollList
          for(let i = 0; i < payList.length; i++){
              //In case we found the holiday we make a little mark 
              if(payList[i].FlagReason == holidayList[u].nameEn){
                holidayList[u].found = true;
                console.log('Holiday found!')
                break;
              }else if(payList[i].FlagReason != holidayList[u].nameEn && holidayList[u].found != true){
                holidayList[u].found = false;
              }
          }
        }
        console.log(holidayList)
        this.addHolidays(holidayList)
      }else{
        console.log("No holiday found");
      }
  }

  addHolidays = async(holidaysList) =>{

    //First we need to get an average of hours that this employee worked in the past 4 weeks
    var requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    function beforeDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() - days);
      return result;
    }

    //We set a range of days from the ending of the payroll period to 28 days before that
    let endTime = this.state.payrollPeriod.end;
    let startTime = Time.makeNormalDateToServer(beforeDays(endTime,28));
    let user = this.state.payrollEmployee;
    
    //We calculate the average hours
    let averageHours;
    await fetch("https://dashboard.realsexdoll.info/php/payroll/getavarage.php?startDate="+startTime+"&endDate="+endTime+"&name="+user, requestOptions)
      .then(response => response.json())
      .then(result => averageHours = Time.calculateAverageTimeWorked(result))
      .catch(error => console.log('error', error));
    
      let minutes = averageHours%1;
      minutes = minutes.toFixed(2)*60;
      
    //In case we don't have enough history:
    if(averageHours == 0){
      console.log("Not enough history")
      return;
    }

    //For each holiday found we add to the database
    for(let holiday of holidaysList){

      let user = this.state.payrollEmployee;
      let start = new Date(holiday.observedDate+"T10:00:00");
      //Add hours
      let end = new Date(holiday.observedDate+"T10:00:00").setHours(start.getHours() + averageHours);
      //Add minutes
      end = new Date(end).setMinutes(start.getMinutes() + minutes)
      let reason = holiday.nameEn;
      let location = "Holiday";

      end = new Date(end);

      end = Time.convertDate(end);
      start = Time.convertDate(start);

      if(holiday.found == false){
        this.createShift(user,start,end,reason,location);
      }
      
    }

  }

  createShift = async(user,start,end,reason,location) =>{

    //Adds to the front end
    let shiftsList = this.state.payrollList;
    let shift = {
      Username:user,
      StartTime:start,
      EndTime: end,
      FlagReason: reason,
      WorkLocation: location,
      OriginalStartTime:start,
      OriginalEndTime:end,
      HrStartTime: start,
      HrEndTime: end,
      BreakMinutes:0,
      UserVerified:"1"
    }

    shiftsList.push(shift)
    this.setState({payrollList:shiftsList})

    //Adds to the back end
    var formdata = new FormData();
    formdata.append("username", user);
    formdata.append("startTimeDate", start);
    formdata.append("endTimeDate", end);
    formdata.append("reason", reason);
    formdata.append("location", location);

    var requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };

    await fetch("https://dashboard.realsexdoll.info/php/payroll/addshift.php", requestOptions)
      .then(response => response.text())
      .then(result => console.log(result))
      .catch(error => console.log('error', error));

  }
  
  /**Make a GET request to retrieve the user Timeshifts
   * 
   * @param  {} member
   * @param  {} period
   *
   */
  callPayroll = async(member , period) =>{
    this.setState({payrollList:[]})

    let startingDate = period.start;
    let endingDate = period.end;
    
    const APIlink = "https://dashboard.realsexdoll.info/php/payroll/getuserpayroll.php?"
    let linkEmployeeName = "employeeName="+member;
    let linkStartDate = "&startDate="+startingDate;
    let linkEndDate = "&endDate="+endingDate+"T23:59";

    //Example of the full API Call
    //https://dashboard.realsexdoll.info/php/getuserpayroll.php?employeeName=Pedro&startDate=2022-10-03&endDate=2022-10-12
    
    
    let APICall = APIlink+linkEmployeeName+linkStartDate+linkEndDate;

    //Here is where the API request happens and we get the result
    let fetchRequest = await fetch(APICall);
    const result = await fetchRequest.json();
    this.setState({payrollList:result});
    
  }

  //Opens and closes the ReportGenerator
  openCloseReportGenerator = () =>{
    let genStatus = this.state.payrollGenerator
    this.setState({payrollGenerator:!genStatus});
  }
  
  //Opens and closes the Vacation Request
  openCloseVacationRequest = () =>{
    let vacStatus = this.state.requestVacation
    this.setState({requestVacation:!vacStatus});
  }

  /**
   * Get the employees from the database and put into the
   * dropdown selector
   */
  loadMembers = async()=>{
    let membersArray = await Members.getMembersSelectList();
    this.setState({members:membersArray})
  }

  componentDidMount = () =>{

    this.loadMembers()

  }

  render() {

    let selectedMember;
    //These are the members available right now
    const members = this.state.members;

    //Builds the member selector
    const selectMember =
        <Select
            options={members}
            onChange={this.changeEmployee}
            value={selectedMember}
        />

    let selectedPeriod;
    const periodOptions = Time.PayrollDates( {horizonYears: 2});
    const selectPeriods = 
      <Select
          options={periodOptions}
          value={selectedPeriod}
          onChange={this.changePeriod}
      />

    let payrollListHTML;

    if(this.state.payrollList.length > 0){payrollListHTML = this.state.payrollList.map((row, index) =>
      <PayrollRow
        key={index}
        Id ={row.Id}
        Username = {row.Username}
        OriginalStartTime = {row.OriginalStartTime}
        OriginalEndTime = {row.OriginalEndTime}
        StartTime = {row.StartTime}
        EndTime = {row.EndTime}
        HRStartTime = {row.HrStartTime}
        HREndTime = {row.HrEndTime}
        BreakMinutes = {row.BreakMinutes}
        UserVerified = {row.UserVerified}
        UserFlagged = {row.UserFlagged}
        FlagReason = {row.FlagReason}
        WorkLocation = {row.WorkLocation}
      />
    )}

     //Render the payroll generator
     let payrollGeneratorHTML;
    
     if(this.state.payrollGenerator){
       payrollGeneratorHTML = <PayrollReportCreator 
           close={this.openCloseReportGenerator}
           user={this.props.user}
         />
     }

     //Render the Vacation Requester
     let vacationRequesterHTML;
    
     if(this.state.requestVacation){
      vacationRequesterHTML = <RequestVacation 
           close={this.openCloseVacationRequest}
           user={this.props.user}
         />
     }

    return(
      <div>
        {payrollGeneratorHTML}
        {vacationRequesterHTML}
        <div className='pop-up' onClick={this.props.close}></div>
        <div className="container pop-up-window payroll-window">
            <div className="row">
                <div className="col-12 container p-4">
                  <div className='row m2'>
                    <div className='col-4'>
                      <h2>Payroll</h2>
                    </div>
                    <div className='col-8 d-flex flex-row-reverse'>
                      <button onClick={this.openCloseVacationRequest} className='mx-1'>Request Vacation</button>
                      <button onClick={this.openCloseReportGenerator} className='mx-1'>Payroll Reports</button>
                    </div>
                  </div>
                  <div className='row mb-3'>
                    <div className='col-4'>
                      <label className="form-label">Employee</label>
                      {selectMember}
                    </div>
                    <div className='col-4'>
                      <label className="form-label">Period</label>
                      {selectPeriods}
                    </div>
                  </div>
                  <div className='payroll-section'>
                    <div className='payroll-table-container'>
                      <table className="table payroll-table">
                        <thead style={{zIndex: 0}}>
                            <tr>
                              <th>Shift #</th>
                              <th>Name</th>
                              <th>Logged Start Date</th>
                              <th>Logged End Date</th>
                              <th>Employee Start Date</th>
                              <th>Employee End Date</th>
                              <th>Unpaid Breaks (min)</th>
                              <th>Correction Request</th>
                              <th>Request Reason</th>
                              <th>Difference</th>
                              <th>Approved Start Time HR</th>
                              <th>Approved End Time HR</th>
                              <th>Approve</th>
                              <th>Location</th>
                              <th>Total Paid Time</th>
                              <th>Screenshot</th>
                            </tr>
                        </thead>
                        <tbody>
                          {payrollListHTML}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
    );
  }
}

export default Payroll;